module.exports = __webpack_public_path__ + "static/media/support-icon.f9667375.svg";